export type GlobalSearchParams = {
  s?: string;
  bp_search?: number;
  view?: string;
};

export function validateGlobalSearchParams(
  search: Record<string, unknown>,
): GlobalSearchParams {
  return {
    s: search.s ? String(search.s) : undefined,
    bp_search: search.bp_search ? Number(search.bp_search) : undefined,
    view: search.view ? String(search.view) : undefined,
  };
}

export function buildGlobalSearchParams(term: string): GlobalSearchParams {
  const normalized = term.trim();

  if (!normalized) {
    return {
      s: undefined,
      bp_search: undefined,
      view: undefined,
    };
  }

  return {
    s: normalized,
    bp_search: 1,
    view: 'content',
  };
}

export function isGlobalSearchMode(params: GlobalSearchParams): boolean {
  return Boolean(params.s?.trim()) && params.bp_search === 1;
}
